import { render } from "./ProccessPayment.vue?vue&type=template&id=4b3f7742"
import script from "./ProccessPayment.vue?vue&type=script&lang=js"
export * from "./ProccessPayment.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__